import React, { useState, useEffect } from "react";
import { Button, Table, message } from "antd";
import { EditTwoTone } from "@ant-design/icons";
import axiosInstance from "@/axios/axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import "./index.scss";

const Paper = () => {
  let navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [videoList, setVideoList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys, selectedRows) => {
      console.log(selectedKeys, selectedRows);
      setSelectedRowKeys(selectedKeys);
      setSelectedRows(selectedRows);
    },
  };
  const getDataList = async (
    page = pagination.current,
    limit = pagination.pageSize
  ) => {
    try {
      const response = await axiosInstance.get(
        `/paper/account/list?page=${page}&limit=${limit}`
      );
      setVideoList(response.data.data);
      setPagination({
        ...pagination,
        current: page,
        total: response.data.page.totalCount,
      });
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  useEffect(() => {
    getDataList(); // 组件挂载后获取用户信息
  }, []); // 空依赖数组确保只运行一次// 空数组作为依赖项表示这个 effect 只在组件挂载时运行一次
  const jcShow = () => {
    const formData = new FormData();
    formData.append("paperIdArray", selectedRowKeys.join(","));
    formData.append("status", 1);

    try {
      axiosInstance
        .post("/paper/account/update", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code === 10000) {
            getDataList(pagination.current, pagination.pageSize);
            message.success("修改成功");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const jcDisable = () => {
    const formData = new FormData();
    formData.append("paperIdArray", selectedRowKeys.join(","));
    formData.append("status", 2);

    try {
      axiosInstance
        .post("/paper/account/update", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code === 10000) {
            getDataList(pagination.current, pagination.pageSize);
            message.success("修改成功");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const deleteCom = () => {
    const formData = new FormData();
    formData.append("paperIdArray", selectedRowKeys.join(","));
    formData.append("deleteFlag", "1");

    try {
      axiosInstance
        .post("/paper/account/update", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code === 10000) {
            getDataList(pagination.current, pagination.pageSize);
            message.success("修改成功");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const toDetail = (record) => {
    navigate("/publishPaper", { state: { id: record.paperId } });
  };
  const columns = [
    {
      title: "论文标题/标签",
      dataIndex: "title",
      width: "35%",
      ellipsis: true,
    },
    {
      title: "发布日期",
      dataIndex: "createTime",
      width: "20%",
    },
    {
      title: "状态",
      dataIndex: "status",
      width: "20%",
      render: (text, record, k) => {
        return <span>{text == "1" ? "展示" : "隐藏"}</span>;
      },
    },
    {
      title: "操作",
      dataIndex: "we",
      width: "25%",
      render(t, record) {
        // <CloseCircleTwoTone />
        return (
          <span>
            <EditTwoTone
              style={{ marginRight: "10px" }}
              onClick={() => toDetail(record)}
            />{" "}
          </span>
        );
      },
    },
  ];
  const onRow = (record) => ({
    onClick: (event) => {
      const isSelected = selectedRowKeys.includes(record.paperId);
      let newSelectedRowKeys = isSelected
        ? selectedRowKeys.filter((key) => key !== record.paperId)
        : [...selectedRowKeys, record.paperId];
      // 你可以在这里添加其他逻辑，比如如果只想单选，就清空其他选中的项
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(
        newSelectedRowKeys.map((key) =>
          videoList.find((item) => item.paperId === key)
        )
      );
    },
  });
  useEffect(() => {
    getDataList();
  }, [pagination.current, pagination.pageSize]);
  const handleTableChange = (pagination, filters, sorter) => {
    setPagination({
      ...pagination,
    });
  };
  const handlePageSizeChange = (value) => {
    setPagination({
      ...pagination,
      pageSize: value,
      current: 1,
    });
  };

  const pageSizeOptions = ["10", "20", "50", "100"];
  const paginationLocale = {
    items_per_page: "/页",
    jump_to: "跳至",
    jump_to_confirm: "确认",
    page: "页",
    prev_page: "上一页",
    next_page: "下一页",
    prev_5: "向前 5 页",
    next_5: "向后 5 页",
    total_items: "共 {total} 条",
    total_pages: "共 {total} 页",
  };

  const showTotal = (total, range) => {
    return `共 ${total} 条`;
  };
  return (
    <div className="personal_right">
      <div className="personal_right_top">
        <Button
          type="primary"
          onClick={() => {
            window.open("/publishPaper", "_blank");
          }}
        >
          发布
        </Button>
        <Button type="primary" onClick={jcShow}>
          展示
        </Button>
        <Button onClick={jcDisable}>隐藏</Button>
        <Button
          type="dashed"
          disabled={!selectedRowKeys.length}
          onClick={deleteCom}
        >
          删除
        </Button>
      </div>
      <div className="personal_right_bot">
        <Table
          onRow={onRow}
          rowSelection={rowSelection}
          columns={columns}
          dataSource={videoList}
          rowKey={(record) => record.paperId}
          scroll={{ y: "42vh" }}
          pagination={{
            ...pagination,
            showSizeChanger: true,
            pageSizeOptions: pageSizeOptions,
            onShowSizeChange: (current, size) => handlePageSizeChange(size),
            showTotal: showTotal,
            locale: paginationLocale,
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  );
};
export default Paper;
